exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mp-context-panel {\n  position: absolute;\n}\n:host {\n  position: absolute;\n}\nmp-context-panel[relative-parent-positioning] mp-context-panel-internal {\n  position: relative;\n}\n:host([relative-parent-positioning]) mp-context-panel-internal {\n  position: relative;\n}\n", ""]);

// exports
